function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import data_strategy_service from '@/services/data_strategy_service';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
var NOT_REPORTS = 'There are not report to assign';
export default {
  name: 'MvpList',
  components: {},
  data: function data() {
    return {
      fields: [{
        key: 'description',
        label: 'Description',
        sortable: true
      }, {
        key: 'type',
        label: 'Type'
      }, {
        key: 'priority',
        label: 'Priority'
      }, {
        key: 'cost',
        label: 'Cost'
      }, {
        key: 'duration',
        label: 'Duration'
      }, {
        key: 'creation_date',
        label: 'Creation Date',
        class: 'text-center'
      }, {
        key: 'creation_user',
        label: 'Creation User',
        class: 'text-center'
      }, {
        key: 'action',
        label: '',
        class: 'w-15 text-center'
      }],
      items: [],
      // Representa la colección de objetos
      data_list: [],
      new_item: {},
      // representa los datos generales
      messageEmptyList: textsDefaul.LOADING,
      path_name: '',
      limit: envConfig.pagintaionSize,
      page: 1,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      pagination: {
        total: 0,
        limit: 10,
        offset: 0,
        current: 1
      },
      isValidateLink: false,
      show_editor: false,
      readonly: false,
      nodes: {
        node1: {
          name: "Node 1"
        },
        node2: {
          name: "Node 2"
        },
        node3: {
          name: "Node 3"
        },
        node4: {
          name: "Node 4"
        }
      },
      edges: {
        edge1: {
          source: "node1",
          target: "node2"
        },
        edge2: {
          source: "node2",
          target: "node3"
        },
        edge3: {
          source: "node3",
          target: "node4"
        }
      },
      divisiones: [],
      oportunities: [],
      source_systems: [],
      key_divisions: 0,
      key_macro_process: 0,
      new_macro_process: {},
      type_objects: [{
        value: 'TABLE',
        text: 'Table'
      }, {
        value: 'VIEW',
        text: 'View'
      }, {
        value: 'TBL_DATASOURCE',
        text: 'TBL Datasource'
      }, {
        value: 'TBL_DASHBOARD',
        text: 'TBL Dashboard'
      }, {
        value: 'PBI_DATASET',
        text: 'PBI Dataset'
      }, {
        value: 'PBI_REPORT',
        text: 'PBI Report'
      }, {
        value: 'GDS_REPORT',
        text: 'GDS Report'
      }],
      plan_pilares: [],
      size_modal: 'md',
      new_delivery: {},
      new_detail: {},
      key_industries: 0,
      key_details: 0,
      key_deliveries: 0,
      key_entities: 0,
      entities: [],
      is_add_detail: false,
      key_critical_factors: 0,
      new_critical_factor: '',
      key_used_resources: 0,
      new_used_resource: {}
    };
  },
  computed: {
    isEmptyTable: function isEmptyTable() {
      return !this.items.length;
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    getDivisionName: function getDivisionName() {
      var _this = this;
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var find = _this.divisiones.find(function (x) {
          return x.value == item.division_id;
        });
        if (find) return find.text;
        return "";
      };
    },
    getPlanPilarName: function getPlanPilarName() {
      var _this2 = this;
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var find = _this2.plan_pilares.find(function (x) {
          return x.value == item.plan_pilar_id;
        });
        if (find) return find.text;
        return "";
      };
    },
    getOportunityName: function getOportunityName() {
      var _this3 = this;
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var find = _this3.oportunities.find(function (x) {
          return x.value == item.oportunity_id;
        });
        if (find) return find.text;
        return "";
      };
    }
  },
  created: function created() {
    this.reloadList();
    this.loadDivisions();
    this.loadPlanPilares();
    this.loadEntities();
    this.loadOportunities();
  },
  methods: {
    loadEntities: function loadEntities() {
      var _this4 = this;
      var defaultParams = {
        pagination: {
          limit: 1000,
          offset: 0
        }
      };
      data_strategy_service.getEntityAll(defaultParams).then(function (res) {
        res.data.forEach(function (element) {
          _this4.entities.push({
            id: element.id,
            name: element.name,
            description: element.description,
            division_id: element.division_id
          });
        });
      });
    },
    loadPlanPilares: function loadPlanPilares() {
      var _this5 = this;
      var defaultParams = {
        pagination: {
          limit: 1000,
          offset: 0
        }
      };
      data_strategy_service.getPlanPilarAll(defaultParams).then(function (res) {
        res.data.forEach(function (element) {
          _this5.plan_pilares.push({
            text: element.name,
            value: element.id
          });
        });
      });
    },
    loadOportunities: function loadOportunities() {
      var _this6 = this;
      var defaultParams = {
        pagination: {
          limit: 1000,
          offset: 0
        }
      };
      data_strategy_service.getOportunityAll(defaultParams).then(function (res) {
        res.data.forEach(function (element) {
          _this6.oportunities.push({
            text: element.description,
            value: element.id
          });
        });
      });
    },
    loadDivisions: function loadDivisions() {
      var _this7 = this;
      var defaultParams = this.processParams(null);
      data_strategy_service.getDivisionAll(defaultParams).then(function (res) {
        res.data.forEach(function (element) {
          _this7.divisiones.push({
            id: element.id,
            name: element.name
          });
        });
      });
    },
    processParams: function processParams(params) {
      var filters = [{
        key: 'environment',
        operator: 'in',
        value: [ENVIRONMENT_FLOW.DEV, ENVIRONMENT_FLOW.TEST]
      }];
      if (params && params.clauses) {
        var clauses = params.clauses;
        if (clauses.query_type !== 'advanced') {
          for (var _i = 0, _Object$keys = Object.keys(clauses); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (clauses[key] && clauses[key].trim()) {
              filters.push({
                key: key,
                operator: '==',
                value: clauses[key].trim()
              });
            }
          }
        }
      }
      return _objectSpread({
        domain: window.userInfo.domain,
        pagination: {
          limit: this.pagination.limit,
          offset: this.pagination.offset
        },
        filters: filters
      }, params);
    },
    reloadList: function reloadList(params) {
      var _this8 = this;
      this.items = [];
      var defaultParams = this.processParams(params);
      this.messageEmptyList = textsDefaul.LOADING;
      data_strategy_service.getMvpAll(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this8.items = res.data;
          _this8.data_list = Object.assign([], res.data);
          _this8.pagination.total = res.data.length;
          _this8.currentPage = 1;
          _this8.messageEmptyList = res.data.length === 0 ? NOT_REPORTS : null;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    validateKey: function validateKey(key, model) {
      if (!(key in model)) return false;
      if (model[key].toString().trim() == 0) return false;
      return true;
    },
    validateNew: function validateNew() {
      console.log(this.new_item);
      if (!this.validateKey('description', this.new_item)) {
        this.$toast.warning("Enter the description!");
        return false;
      }
      if (!this.validateKey('type', this.new_item)) {
        this.$toast.warning("Enter the type!");
        return false;
      }
      if (!this.validateKey('priority', this.new_item)) {
        this.$toast.warning("Enter the priority!");
        return false;
      }
      if (!this.validateKey('deliverables', this.new_item)) {
        this.$toast.warning("Enter the deliverables!");
        return false;
      }
      if (!this.validateKey('duration', this.new_item)) {
        this.$toast.warning("Enter the duration!");
        return false;
      }
      if (!this.validateKey('cost', this.new_item)) {
        this.$toast.warning("Enter the cost!");
        return false;
      }
      if (!this.validateKey('entities', this.new_item)) {
        this.$toast.warning("Enter the entities!");
        return false;
      }
      if (!this.validateKey('plan_pilar_id', this.new_item)) {
        this.$toast.warning("Select the strategic plan!");
        return false;
      }
      if (!this.validateKey('details', this.new_item)) {
        this.$toast.warning("Enter the details!");
        return false;
      }
      if (!this.validateKey('oportunity_id', this.new_item)) {
        this.$toast.warning("Select the oportunity!");
        return false;
      }
      return true;
    },
    onSaveMvp: function onSaveMvp() {
      var _this9 = this;
      var ent = this.entities.filter(function (x) {
        return x.check == true;
      });
      if (ent.length > 0) {
        this.new_item.entities = ent;
      }
      if (!this.validateNew()) return;
      var data = {
        values: this.new_item
      };
      if (this.new_item.id) {
        data_strategy_service.updateMvp(data).then(function (res) {
          console.log(res);
          if (res.success) {
            _this9.$bvModal.hide('my-modal-mvp');
            _this9.$toast.success("Successful request!");
            _this9.reloadList();
          } else {
            _this9.$toast.warning(res.message);
          }
        });
      } else {
        data_strategy_service.createMvp(data).then(function (res) {
          console.log(res);
          if (res.success) {
            _this9.$bvModal.hide('my-modal-mvp');
            _this9.$toast.success("Successful request!");
            _this9.reloadList();
          } else {
            _this9.$toast.warning(res.message);
          }
        });
      }
    },
    onDelete: function onDelete(item) {
      var _this0 = this;
      console.log(item);
      var data = {
        "mvp_id": item.id
      };
      data_strategy_service.deleteMvpById(data).then(function (res) {
        console.log(res);
        if (res.success) {
          _this0.$bvModal.hide('my-modal-mvp');
          _this0.$toast.success("Successful request!");
          _this0.reloadList();
        } else {
          _this0.$toast.warning(res.message);
        }
      });
    },
    onCloseModal: function onCloseModal() {
      this.$bvModal.hide('my-modal-mvp');
      this.new_item = {};
    },
    onCancel: function onCancel() {
      this.onCloseModal();
    },
    onPage: function onPage(page) {
      this.page = page;
      this.reloadList({
        page: page
      });
    },
    changePagina: function changePagina(pagina) {},
    onOpenNew: function onOpenNew() {
      this.new_item = {};
      this.entities.forEach(function (x) {
        x.check = false;
      });
      this.isValidateLink = true;
      this.$refs['my-modal-mvp'].show();
    },
    onAddDelivery: function onAddDelivery() {
      var _this1 = this;
      this.$nextTick().then(function () {
        if (!_this1.validateKey('name', _this1.new_delivery)) {
          _this1.$toast.warning("Enter the deliverable's name!");
          return;
        }
        if ('deliverables' in _this1.new_item) {
          _this1.new_item.deliverables.push(_this1.new_delivery);
        } else {
          _this1.new_item.deliverables = [_this1.new_delivery];
        }
        _this1.key_deliveries += 1;
        _this1.new_delivery = {};
        //this.$refs['okrs-list'].$forceUpdate()
      });
    },
    onDelDelivery: function onDelDelivery(index) {
      this.new_item.deliverables.splice(index, 1);
      this.key_deliveries += 1;
    },
    onEdit: function onEdit(item) {
      var _this10 = this;
      this.new_item = Object.assign({}, item);
      this.entities.forEach(function (element) {
        var filter = _this10.new_item.entities.filter(function (x) {
          return x.id == element.id;
        });
        if (filter.length > 0) {
          element.check = true;
        } else {
          element.check = false;
        }
      });
      this.$refs['my-modal-mvp'].show();
    },
    onIsAddDetail: function onIsAddDetail() {
      this.is_add_detail = true;
    },
    isAddDetail: function isAddDetail() {
      if (this.is_add_detail) {
        return 'col-6';
      } else {
        return 'col-12';
      }
    },
    onCancelAddDetail: function onCancelAddDetail() {
      this.is_add_detail = false;
      this.new_detail = {};
      this.new_critical_factor = '';
      this.new_used_resource = {};
    },
    onAddCriticalFactor: function onAddCriticalFactor() {
      var _this11 = this;
      this.$nextTick().then(function () {
        if (_this11.new_critical_factor.trim().length == 0) {
          _this11.$toast.warning("Enter a critical factor!");
          return;
        }
        if ('critical_factors' in _this11.new_detail) {
          _this11.new_detail.critical_factors.push(_this11.new_critical_factor);
        } else {
          _this11.new_detail.critical_factors = [_this11.new_critical_factor];
        }
        _this11.key_critical_factors += 1;
        _this11.new_critical_factor = '';
        //this.$refs['okrs-list'].$forceUpdate()
      });
    },
    onDelCriticalFactor: function onDelCriticalFactor(index) {
      this.new_item.critical_factors.splice(index, 1);
      this.key_critical_factors += 1;
    },
    onAddDetail: function onAddDetail() {
      var _this12 = this;
      this.$nextTick().then(function () {
        if (!_this12.validateKey('outcome', _this12.new_detail)) {
          _this12.$toast.warning("Enter the detail's outcome!");
          return;
        }
        if ('details' in _this12.new_item) {
          _this12.new_item.details.push(_this12.new_detail);
        } else {
          _this12.new_item.details = [_this12.new_detail];
        }
        _this12.key_details += 1;
        _this12.new_detail = {};
        //this.$refs['okrs-list'].$forceUpdate()
        _this12.onCancelAddDetail();
      });
    },
    onDelDetail: function onDelDetail(index) {
      this.new_item.details.splice(index, 1);
      this.key_deliveries += 1;
    },
    onAddUsedResource: function onAddUsedResource() {
      var _this13 = this;
      this.$nextTick().then(function () {
        if (!_this13.validateKey('description', _this13.new_used_resource)) {
          _this13.$toast.warning("Enter the user resource's description!");
          return;
        }
        if (!_this13.validateKey('total', _this13.new_used_resource)) {
          _this13.$toast.warning("Enter the total user resource!");
          return;
        }
        if ('used_resources' in _this13.new_detail) {
          _this13.new_detail.used_resources.push(_this13.new_used_resource);
        } else {
          _this13.new_detail.used_resources = [_this13.new_used_resource];
        }
        _this13.key_details += 1;
        _this13.new_used_resource = {};
        //this.$refs['okrs-list'].$forceUpdate()
      });
    },
    onDelUsedResource: function onDelUsedResource(index) {
      this.new_detail.used_resources.splice(index, 1);
      this.key_used_resources += 1;
    }
  }
};